<div class="reference-page golden-rules">
  <div class="policy-card">
    <mat-card class="tp-card">
      <mat-card-header class="title-bar">
        <h3 class="title">Golden Rules</h3>
        <div class="row" [ngClass]="isOnEditMode ? 'on-edit-mode': 'on-non-edit-mode'">
          <button mat-button color="white" *ngIf="!isOnEditMode" (click)="isOnEditMode = true">Add/Edit</button>
          <button mat-button color="white" *ngIf="isOnEditMode" (click)="openEditDialog()">Add New</button>
          <button mat-button color="white" *ngIf="isOnEditMode" (click)="isOnEditMode = false; newGoldenRule= null;">
            Back
          </button>
        </div>
      </mat-card-header>
<!--      <div class="row new-rule-editor" *ngIf="isOnEditMode">-->
<!--        &nbsp;<input class="form-control" id="inputdefault" type="text" [(ngModel)]="newGoldenRule" autocomplete="off"-->
<!--                     name="newGoldenRule">-->
<!--        <div class="save-rule-btn fa fa-plus" (click)="newGoldenRule && addRule()"></div>-->
<!--      </div>-->
      <div class="golden-rule-container">
        <br>
        <perfect-scrollbar>
          <div class="rule-list">
            <ol>
              <li class="rule" *ngFor="let rule of goldenRulesList let i = index">
                <div>{{rule.rule}}&nbsp;
                &nbsp;<i *ngIf="isOnEditMode"
                         class="fa fa-pencil file-delete-icon" (click)="openEditDialog(rule)" aria-hidden="true"></i>&nbsp;&nbsp;<i
                  *ngIf="isOnEditMode"
                  class="fa fa-trash file-delete-icon" (click)="deleteRule(rule._id)" aria-hidden="true"></i></div></li>
            </ol>
          </div>
        </perfect-scrollbar>
      </div>
    </mat-card>
  </div>
</div>


